/**
 * useNonMainSEO
 *
 * For non-MAIN domains (juridiceai.ro, consultantajuridicaai.ro, etc.),
 * any route that is NOT the homepage is a duplicate of chat.legeaaplicata.ro.
 * This hook automatically injects:
 *  - noindex, nofollow (robots meta)
 *  - canonical link pointing to chat.legeaaplicata.ro + current path
 *
 * Usage: Call at the top of App.tsx or in a route wrapper for non-main domains.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// No variant imports needed

export function useNonMainSEO() {
    const location = useLocation();

    useEffect(() => {
        // Main domain: we're good
        return;
    }, [location.pathname, location.search]);
}
